import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import RouteLoadingFallback from '../infrastructure/RouteLoadingFallback.js';
import { isAlwaysAvailableSkill } from '../infrastructure/paywallConfig.js';

/**
 * Allow skill-complete for signed-in users, or guests who finished a free-tier skill.
 */
export default function SkillCompleteGate({
  isAuthenticated,
  authChecked,
  userId,
  children,
}) {
  const location = useLocation();
  const completedSkillId = location.state?.skillId;
  const isGuestComplete = !isAuthenticated
    && completedSkillId != null
    && isAlwaysAvailableSkill(completedSkillId);

  if (!authChecked) {
    return <RouteLoadingFallback />;
  }

  if (isAuthenticated) {
    return children;
  }

  if (isGuestComplete) {
    return (
      <>
        {React.Children.map(children, (child) => (
          React.isValidElement(child)
            ? React.cloneElement(child, { userId: '', isGuest: true })
            : child
        ))}
      </>
    );
  }

  if (!completedSkillId) {
    return <Navigate to="/sectionHome" replace />;
  }

  return (
    <Navigate
      to="/loginWithGoogle"
      replace
      state={{ from: location.pathname }}
    />
  );
}
